import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class MaritalStatutesService {
  private iContactURL;

  constructor(private http: HttpClient) {
    const config = environment;
    this.iContactURL = config.apiContactAdminBaseUrl;
  }

  public fetchMaritalStatutes(): Observable<string[]> {
    return this.http.get<string[]>(`${this.iContactURL}/Global/etatCivils`);
  }
}
